import { z } from "zod";

import { validationEmailErrorMessages } from "../i18n/validation-error-codes.ts";

export const maxCharacters = 100;

export const emailSchema = z
  .string()
  .min(1, { message: validationEmailErrorMessages.required.id })
  .max(maxCharacters, { message: validationEmailErrorMessages.max.id })
  .superRefine((value, ctx) => {
    // пустое значение проверяется через min(1) — пропускаем формат
    if (!value) {
      return;
    }

    // только латинские буквы, цифры и разрешенные спец.символы
    if (!/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.@-]+$/.test(value)) {
      ctx.addIssue({
        code: "custom",
        message: validationEmailErrorMessages.invalidFormat.id,
      });
      return;
    }

    const atIndex = value.indexOf("@");

    // должен содержать @
    if (atIndex === -1) {
      ctx.addIssue({
        code: "custom",
        message: validationEmailErrorMessages.invalidFormat.id,
      });
      return;
    }

    // только один @
    if (value.indexOf("@", atIndex + 1) !== -1) {
      ctx.addIssue({
        code: "custom",
        message: validationEmailErrorMessages.invalidFormat.id,
      });
      return;
    }

    const localPart = value.slice(0, atIndex);
    const domainPart = value.slice(atIndex + 1);

    // минимум 2 символа в имени ящика
    if (localPart.length < 2) {
      ctx.addIssue({
        code: "custom",
        message: validationEmailErrorMessages.invalidFormat.id,
      });
    }

    // домен: имя + "." + зона минимум 2 символа (например "a.aa")
    if (!/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(domainPart)) {
      ctx.addIssue({
        code: "custom",
        message: validationEmailErrorMessages.invalidFormat.id,
      });
    }
  });
